import { hasPermission } from "./permissionStorage";
import {
  canAccessAnyFinanceArea,
  canAccessFinanceModule,
  canViewApplicationCommissionReport,
  canViewCommissionInstallmentsQueue,
  canViewApplicationInvoices,
  canViewCommissionInvoices,
  canViewCommissionModule,
  canViewProfessionalCost,
} from "./invoicePermissionHelpers";

/** Top-level sidebar sections (opt-in: must have permission enabled). */
export function isSidebarSectionVisible(sectionTitle) {
  switch (sectionTitle) {
    case "Manage Accounts":
      return hasPermission("accounts");
    case "Manage Agents":
      return hasPermission("agents");
    case "Manage Clients":
      return (
        hasPermission("clients") ||
        hasPermission("external_clients") ||
        hasPermission("leads") ||
        hasPermission("reports") ||
        hasPermission("all_followups") ||
        hasPermission("my_clients_followups")
      );
    case "Manage Applications":
      return hasPermission("clients");
    case "Manage Providers":
      return hasPermission("providers");
    case "Manage Finance":
      return canAccessAnyFinanceArea();
    case "Branches":
      return hasPermission("manage_branches");
    case "Reporting":
      return hasPermission("reports");
    case "Events":
      return hasPermission("show_events");
    case "HR Management":
      return hasPermission("hr-management");
    case "Manage CheckList":
      return hasPermission("manage_checklist");
    case "SOP & Policies":
      return hasPermission("view_sop_and_policies");
    case "Company Forms":
    case "Company Documents":
      return true;
    default:
      return true;
  }
}

export function isSidebarSubItemVisible(subItem) {
  const title = subItem?.title;
  const path = subItem?.path || "";

  switch (title) {
    case "View Clients":
      return hasPermission("clients");
    case "View External Clients":
      return hasPermission("external_clients");
    case "View Leads":
      return hasPermission("leads");
    case "Reports":
      return hasPermission("reports");
    case "Follow-ups":
      return hasPermission("all_followups");
    case "My Follow-ups":
      return (
        hasPermission("my_clients_followups") ||
        hasPermission("my_providers_followups") ||
        hasPermission("all_followups")
      );
    case "View Commissions":
      return hasPermission("show_application_commission");
    case "Attendance":
      return hasPermission("show_attendance");
    case "Manage Leaves":
      return hasPermission("manage_leaves");
    case "Manage Roles":
      return hasPermission("manage_roles");
    case "Alerts":
      return hasPermission("can_create_alerts");
    case "View Daily Reports":
      return hasPermission("hr-management");
    case "SOP Categories":
    case "Manage SOP":
      return hasPermission("upload_sop_and_policies");
    case "Manage Company Forms":
    case "Manage documents":
    case "Upload documents":
      return (
        hasPermission("upload_company_forms") ||
        hasPermission("approve_company_forms")
      );
    case "Approve documents":
      return hasPermission("approve_company_forms");
    case "Form Categories":
    case "Document categories":
      return (
        hasPermission("upload_company_forms") ||
        hasPermission("approve_company_forms")
      );
    case "Application Fee Rule":
    case "Discount Rule":
    case "Health Insurance":
    case "GST Settings":
    case "Invoice Branding":
      return canAccessFinanceModule();
    case "Invoices":
      return canViewApplicationInvoices() || canViewCommissionInvoices();
    case "Commissions":
      return canViewCommissionModule();
    case "Installments":
      return canViewCommissionInstallmentsQueue();
    default:
      break;
  }

  if (path === "/company-forms/manage") {
    return (
      hasPermission("upload_company_forms") ||
      hasPermission("approve_company_forms")
    );
  }
  if (path === "/company-forms/approve") {
    return hasPermission("approve_company_forms");
  }
  if (path === "/company-forms/categories") {
    return (
      hasPermission("upload_company_forms") ||
      hasPermission("approve_company_forms")
    );
  }

  if (
    path === "/finance/invoices" ||
    path === "/finance/invoices/commission" ||
    path === "/finance/invoices/application"
  ) {
    return canViewApplicationInvoices() || canViewCommissionInvoices();
  }
  if (path === "/commissions-invoices") {
    return canViewCommissionModule();
  }
  if (path === "/finance/commission-installments") {
    return canViewCommissionInstallmentsQueue();
  }
  if (
    path === "/application-fee" ||
    path === "/discount-rule" ||
    path === "/health-insurance" ||
    path === "/finance/gst-settings" ||
    path === "/finance/invoice-branding"
  ) {
    return canAccessFinanceModule();
  }
  if (
    path === "/finance/professtional-cost" ||
    path === "/finance/ProfessionalCost"
  ) {
    return canViewProfessionalCost();
  }
  if (path === "/finance/view-commissions") {
    return canViewApplicationCommissionReport();
  }

  return true;
}
